import React from 'react';
import './BbAds.css';

class Ads extends React.Component
{
  componentDidMount()
  {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  shouldComponentUpdate(nextProps)
  {
    if (nextProps.adSource !== this.props.adSource)
    {
      return true;
    }
    return false;
  }

  render()
  {
    console.log('*** ADVERTISEMENT ***');
    return (
      <div className="x">
        <div className="row gx-0">
          <div className="col-12" style={{ width: '100%' }}>
            <div id="adswrapper">
              <p id="nextgame">
                The next Brain Bout game is seconds away!
              </p>
              <p>
                <img src={this.props.adSource} alt="Brain Bout" />
              </p>
            </div>
            <div className="socialwrapper">
              <p id="twitterfollow">
                <a
                  className="twitter-follow-button"
                  href="https://twitter.com/realBrainBout?ref_src=twsrc%5Etfw"
                  data-size="large"
                  data-show-count="false"
                  target="_blank"
                  rel="noreferrer"
                >
                  Follow @realBrainBout
                </a>
              </p>
              {/* <a target="_blank" href="https://twitter.com/realBrainBout?ref_src=twsrc%5Etfw" className="twitter-follow-button" data-show-count="false" rel="noreferrer">Follow @realBrainBout</a> */}
              <script async src="https://platform.twitter.com/widgets.js" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Ads;
